var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_3469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 3.3335H4.66665C4.31302 3.3335 3.97389 3.47397 3.72384 3.72402C3.47379 3.97407 3.33331 4.31321 3.33331 4.66683V12.6668C3.33331 13.0205 3.47379 13.3596 3.72384 13.6096C3.97389 13.8597 4.31302 14.0002 4.66665 14.0002H11.3333C11.6869 14.0002 12.0261 13.8597 12.2761 13.6096C12.5262 13.3596 12.6666 13.0205 12.6666 12.6668V4.66683C12.6666 4.31321 12.5262 3.97407 12.2761 3.72402C12.0261 3.47397 11.6869 3.3335 11.3333 3.3335H9.99998",
    stroke: "#232633",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 2H7.33333C6.59695 2 6 2.59695 6 3.33333C6 4.06971 6.59695 4.66667 7.33333 4.66667H8.66667C9.40305 4.66667 10 4.06971 10 3.33333C10 2.59695 9.40305 2 8.66667 2Z",
    stroke: "#232633",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 7.3335H7.66669C7.40147 7.3335 7.14712 7.43885 6.95958 7.62639C6.77204 7.81393 6.66669 8.06828 6.66669 8.3335C6.66669 8.59871 6.77204 8.85307 6.95958 9.0406C7.14712 9.22814 7.40147 9.3335 7.66669 9.3335H8.33335C8.59857 9.3335 8.85292 9.43885 9.04046 9.62639C9.228 9.81393 9.33335 10.0683 9.33335 10.3335C9.33335 10.5987 9.228 10.8531 9.04046 11.0406C8.85292 11.2281 8.59857 11.3335 8.33335 11.3335H6.66669",
    stroke: "#232633",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3332V11.9998M8 6.6665V7.33317",
    stroke: "#232633",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_3469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.5d6282484aea343bfae63ff56661d73c.svg";
export { ForwardRef as ReactComponent };